'use client'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { ArrowRight } from 'lucide-react'
import { useTranslations } from 'next-intl'
import Link from 'next/link'

type HelloKittyActionsProps = {
  className?: string
}

/** Cặp nút "Mua ngay" (cuộn tới listing) + "Khám phá BST khác" dùng ở Lifestyle và CTA */
export const HelloKittyActions = ({ className }: HelloKittyActionsProps) => {
  const t = useTranslations('hello_kitty_hardcode.cta')

  return (
    <div
      className={cn(
        'grid w-full gap-2 lg:w-auto lg:auto-cols-max lg:grid-flow-col lg:gap-6',
        className
      )}
    >
      <Button
        size='large'
        variant='black'
        className='h-[50px] px-10'
        onClick={() => {
          document.getElementById('collection-listing')?.scrollIntoView({
            behavior: 'smooth',
          })
        }}
      >
        {t('buy_now')}
        <ArrowRight className='!size-5' />
      </Button>
      <Button
        asChild
        size='large'
        variant='outline-neutral'
        className='h-[50px] px-10'
      >
        <Link href='/highlight-collections'>
          {t('explore_more')}
          <ArrowRight className='!size-5' />
        </Link>
      </Button>
    </div>
  )
}
